import React from 'react';
import { authorConfig } from '../data/siteConfig';
export const AuthorSection = () => {
  const initials = authorConfig.name.split(' ').filter(Boolean).map(p => p[0]).filter((_, i, arr) => i === 0 || i === arr.length - 1).join('').toUpperCase();
  return <section className="bg-familia-light border-t border-familia-lightBorder py-12 md:py-16 px-4 md:px-6" data-id="element-23" data-mp="176drzp88wpgn">
      <div className="max-w-4xl mx-auto w-full" data-id="element-24" data-mp="127izfvkh7mjc">
        <h2 className="text-[26px] sm:text-3xl md:text-4xl font-display font-bold text-familia-ink text-center mb-8 md:mb-10 leading-tight" data-id="element-25" data-mp="ekuet2431fz1">
          ¿Quién está detrás de Vitalidad 360?
        </h2>
        <article className="bg-familia-lightCard border border-familia-lightBorder rounded-2xl p-6 md:p-10 flex flex-col md:flex-row items-center md:items-start gap-6 md:gap-8" data-id="element-26" data-mp="oannnvcubgzl">
          {authorConfig.photoUrl ? <img src={authorConfig.photoUrl} alt={authorConfig.name} width="120" height="120" loading="lazy" decoding="async" className="w-[120px] h-[120px] rounded-full object-cover shrink-0" data-id="element-27" data-mp="3rxnrn05gofu0" /> : <div role="img" aria-label={authorConfig.name} className="w-[120px] h-[120px] rounded-full bg-familia-dark text-white font-display font-bold text-4xl flex items-center justify-center shrink-0" data-id="element-28" data-mp="2von5pscldujs">
              {initials}
            </div>}
          <div className="min-w-0 text-center md:text-left" data-id="element-29" data-mp="34i8kvcso5dtq">
            <h3 className="text-xl md:text-2xl font-display font-bold text-familia-ink" data-id="element-30" data-mp="39e74yo6ys9oc">
              {authorConfig.name}
            </h3>
            <p className="text-[15px] md:text-[16px] font-semibold text-familia-accent mt-1" data-id="element-31" data-mp="2cr2eiemcujw0">
              {authorConfig.role}
            </p>
            <blockquote className="mt-5 space-y-4 text-left" data-id="element-32" data-mp="2lpeg1borf238">
              {authorConfig.bio.map(line => <p key={line} className="text-body text-familia-inkMuted" data-id="element-33" data-mp="2qpabgmje5l76">
                  {line}
                </p>)}
            </blockquote>
            <p className="font-script text-[40px] leading-none text-familia-ink mt-5 text-left" aria-label={`Firma: ${authorConfig.signature}`} data-id="element-34" data-mp="z6z3lepq7up">
              {authorConfig.signature}
            </p>
          </div>
        </article>
      </div>
    </section>;
};